// Shared entry-gateway design tokens — a leaf module (imports nothing), so GatewayShell, GatewayFooter,
// AccountPage and PricingPage can all pull `G` without an import cycle. Single source of the gateway
// palette + type stack (Barlow display, JetBrains Mono, the gold accent).

export const G = {
  MONO: "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
  DISPLAY: "'Barlow', 'Inter', system-ui, sans-serif",
  TEXT: 'var(--c-text)',
  DIM: 'var(--c-text-dim)',
  DIMMER: 'var(--c-slate-600)',
  STEEL: 'var(--c-active)',
  GOLD: 'var(--c-gold)',
  CRIT: 'var(--c-critical)',
  BORDER: 'rgb(var(--c-border-rgb) / 0.9)',
  FAINT: 'rgb(var(--c-text-mute-rgb) / 0.12)',
};

// The shared brand cube background (matte monolith, gold seam) over #050505 with a LEFT-weighted scrim
// (the same stack Landing / Account use): the content column on the left stays legible while the cube
// reads on the right, clear of the content. Used by GatewayShell (login / register) with left-aligned
// content so no card sits on top of the cube.
export const CUBE_BG_LEFT =
  'linear-gradient(180deg, rgb(var(--c-bg-rgb) / 0.55) 0%, rgb(var(--c-bg-rgb) / 0) 14%),' +
  'linear-gradient(90deg, rgb(var(--c-bg-rgb) / 0.94) 0%, rgb(var(--c-bg-rgb) / 0.6) 44%, rgb(var(--c-bg-rgb) / 0.08) 74%),' +
  'linear-gradient(0deg, rgb(var(--c-bg-rgb) / 0.7) 0%, rgb(var(--c-bg-rgb) / 0) 16%),' +
  `url("${process.env.PUBLIC_URL}/entry-bg.jpg") center / cover no-repeat,` +
  'var(--c-bg)';

// The Plans surface (owner 2026-09-25/28): the dark grid-and-floor scene (public/pricing-bg.jpg), no cube, with the
// entry scrims + an even dim. Shared verbatim by Plans and the account security page.
export const PLANS_BG =
  'linear-gradient(180deg, rgb(var(--c-bg-rgb) / 0.6) 0%, rgb(var(--c-bg-rgb) / 0) 15%),' +
  'linear-gradient(90deg, rgb(var(--c-bg-rgb) / 0.75) 0%, rgb(var(--c-bg-rgb) / 0.35) 42%, rgb(var(--c-bg-rgb) / 0.1) 72%),' +
  'linear-gradient(0deg, rgb(var(--c-bg-rgb) / 0.72) 0%, rgb(var(--c-bg-rgb) / 0) 18%),' +
  'linear-gradient(rgb(var(--c-bg-rgb) / 0.35), rgb(var(--c-bg-rgb) / 0.35)),' +
  `url("${process.env.PUBLIC_URL}/pricing-bg.jpg") center / cover no-repeat fixed,` +
  'var(--c-bg)';
